// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2Zkr8","dragIcon":"SortableItem_dragIcon__vA-np","disabled":"SortableItem_disabled__31CK-"};